export interface Check {
  Payee: string;
  CheckNumber: string;
  Amount: number;
  HasBeenPrinted: boolean;
}
export interface PrintChecksConfig {
  Year: number;
  Paydate: string;
  SequenceNumber: number;
  Sort:
    | 'DivEmployeeNumber'
    | 'DivName'
    | 'DeptEmployeeNumber'
    | 'DeptName'
    | 'EmployeeNumber'
    | 'Name';
  CheckType: 'Employee' | 'ThirdParty';
  ThirdPartyChecks: Check[];
  HasDivisions: boolean;
  HasDepartments: boolean;
}
export class PayrollInfo {
  ClientCode: string;
  ClientLocationId: number;
  PayDate: Date;
  PayrollInputMethod: string;
  PayrollFrequency: PayrollFrequency;
  PayrollSeqNo: number;
  PayrollStatus: string;
  PayrollType: string;
  PayrollYear: number;
  FreshdeskTicketId: number;
  DateChanged: Date;
  CorrectionSource: string;
  CorrectionSequence: number;
  BillingType: string;
  SuppressNotifications: boolean;
}

export enum PayrollFrequency {
  BiWeekly = 2,
  Monthly = 4,
  SemiMonthly = 3,
  Weekly = 1
}

export enum PayrollInputMethods {
  'Call_In' = 0,
  'Call_Out' = 1,
  'Email' = 2,
  'Fax' = 3,
  'Automatic' = 4,
  'Online' = 5,
  'Time_Clock' = 6,
  'N Email' = 7,
  'N Fax' = 8,
  'N Automatic' = 9
}
